export class StandardFilter {
  /**
   * Gets or sets the UUID of the user who created this model.
   */
  declare public createdBy: string | null;

  /**
   * Gets or sets the collection of model's UUID to exclude.
   */
  declare public excludedUuids: string[] | null;

  /**
   * Gets or sets the FROM CreateDate.
   * Time should be set to "00:00:00" for comparison on Date "only".
   */
  declare public fromCreateDate: string | null;

  /**
   * Gets or sets the FROM UpdateDate.
   * Time should be set to "00:00:00" for comparison on Date "only".
   */
  declare public fromUpdateDate: string | null;

  /**
   * Gets or sets a free text search filter.
   */
  declare public textFilter: string | null | undefined;

  /**
   * Gets or sets the list of fields the textFilter applies to.
   */
  declare public textFilterFields: string[] | null;

  /**
   * Gets or sets the TO CreateDate.
   * Time should be set to "23:59:59" for comparison on Date "only".
   */
  declare public toCreateDate: string | null;

  /**
   * Gets or sets the TO UpdateDate.
   * Time should be set to "23:59:59" for comparison on Date "only".
   */
  declare public toUpdateDate: string | null;

  /**
   * Gets or sets the UUID of the user who updated this model.
   */
  declare public updatedBy: string | null;

  /**
   * Gets or sets the collection of model's UUID.
   */
  declare public uuids: string[] | null | undefined;
}
